import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import {  ProductsListResponse, ProductVariantResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable, } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OrderAgainService extends HttpService<string, ProductsListResponse> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'order-items');
  }

  getBuyAgainProductsVarients(page=1,limit=30): Observable<ProductsListResponse> {
    return this.getAll('me-purchased-variants?limit=30') as Observable<ProductsListResponse>;
  }

  getProductVarientAutoComplete(searchTerm: string): Observable<ProductVariantResponse> {
    return this.autoCompleteSearch(searchTerm, 'product-variant') as unknown as Observable<ProductVariantResponse>;
  }

  

  
  
}